import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

class _CstStore {

  obs = observable({
    csts: [] as any,
    loading: false as boolean
  })

  async handleLoadCst() {

    let resp = await api.get("/api/codigos/cst")

    this.obs.csts = []

    if (resp.data.length) {

      this.obs.csts = resp.data

    }

  }

  get(codigo: any): any {

    return this.obs.csts.find(x => x.codigo == codigo);

  }

  async handleCreateCst(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cst/create", data)

    if (resp.data.ok) {

      toast.success('CST criado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

  async handleUpdateCst(data: any) {

    let resp = await api_adm.post("/api/admin/codigos/cst/update", data)

    if (resp.data.ok) {

      toast.success('CST atualizado com sucesso!', {});

      return true

    } else {

      toast.warning(resp.data.msg, {});

    }

    return false

  }

  async handleDeleteCst(id: string) {

    let resp = await api_adm.delete(`/api/codigos/cst/${id}`)

    if (resp.data.ok) {

      toast.success('CST deletado com sucesso!', {});

      return true

    } else {

      toast.error(resp.data.msg, {});

    }

    return false

  }

}

export const CstStore = new _CstStore();
